export default "__VITE_ASSET__Bxu7orfV__"